import classNames from 'classnames';
import Icon from 'components/atoms/Icon';
import Num from 'components/atoms/Num';
import { getMessageCredits, pluralWord } from 'utils/index';
import { UserMessageI18n } from 'utils/gloo-types';
import { isNumber } from 'utils/common';
import Typography from 'components/atoms/Typography';

function MessageCreditsInline({
  className,
  credits,
  creditsPrefix,
  iconBackgroundColor,
  iconColor,
  message,
  media,
  textColor,
  warningRight,
}: {
  className?: string;
  credits?: number;
  creditsPrefix?: string;
  iconBackgroundColor?: string;
  iconColor?: string;
  message?: UserMessageI18n | string;
  media?: boolean;
  textColor?: string;
  warningRight?: boolean;
}) {
  const creditsUsed = isNumber(credits) && !Number.isNaN(credits) ? credits : message ? getMessageCredits(message) : 0;
  const textColors = textColor ?? 'text-thryveGray';

  return (
    <>
      <Typography
        variant="xs"
        className={classNames('flex items-center', { 'space-x-2': iconBackgroundColor }, textColors, className)}
      >
        <p className={classNames('text-yellow-900', warningRight ? 'pl-5 order-2' : 'pr-5')}>
          {media && 'Images change your credit count'}
        </p>
        <Icon size={10} name="database" className={`${iconBackgroundColor} ${iconColor} p-1 md:-ml-3 rounded-full`} />
        <div className="space-x-1 flex gap-1 items-center flex-row cursor-pointer">
          {creditsPrefix && creditsPrefix}
          <Num value={creditsUsed} />
          <span className="space-x-1">{pluralWord(creditsUsed, 'Credit')}</span>
        </div>
      </Typography>
    </>
  );
}

export default MessageCreditsInline;
